import cloneDeep from "lodash/cloneDeep"
import isEqual from "lodash/isEqual"
import type {Ref} from "vue"

export const useLocalModel = (modelValue: Ref) => {
    const localModel: Ref = ref(null)

    watch(() => modelValue.value, (newValue) => {
        if (!isEqual(newValue, localModel.value)) localModel.value = cloneDeep(newValue)
    }, {immediate: true, deep: true})

    watch(() => localModel.value, (newValue) => {
        if (!isEqual(newValue, modelValue.value)) modelValue.value = cloneDeep(newValue)
    }, {deep: true})

    return {localModel}
}